import React from 'react';
import Section from '../Section/Section';
import './AvaluoGracias.scss';
import bem from '../../utils/bem';
import Button from '../Button';
import { Link, useHistory } from 'react-router-dom';
import { useEffect } from 'react';
import FormHeader from '../FormHeader/FormHeader';
import Steps from '../Steps';

const AvaluoGracias = ({ avaluos }) => {
  const history = useHistory();

  useEffect(() => {
    window.scrollTo(0, 0);
   if (!avaluos?.personalInfo) {
    history.push('/avaluo/');
   } 
  }, [avaluos.personalInfo, history]);

  const steps = [
    {
      id: 1,
      image: require('../../images/test-drive.svg'),
      title: "TEST DRIVE",
      button: <Button component={Link} to={'/test-drive'} type='red'>Ir</Button>,
      desc: 'Agendá una cita para que podas probar tu vehículo'
    },
    {
      id: 2,
      image: require('../../images/tour-virtual2.svg'),
      title: "TOUR VIRTUAL",
      button: <Button component={'a'} target="_blank" href={'/?marca=Mitsubishi#tour-virtual__frame'} type='red'>Ir</Button>,
      desc: 'Conocé tu vehículo reservado en nuestro Tour virtual'
    },
    {
      id: 3,
      image: require('../../images/cotiza.svg'),
      title: "Cotizá o comprá",
      button: <Button component={Link} to={'/'} type='red'>Ir</Button>,
      desc: 'Compra tu nuevo chuzo.'
    },
    {
      id: 4,
      image: require('../../images/estrenar2.svg'),
      title: "Estrenar",
      desc: '¡Recordá traer tu cédula!'
    }
  ];
  return (
    <div className={`gradient ${bem('avaluo-gracias', {
      loading: avaluos?.isLoadingAvaluo,
      full: true
    })}`}>
      <FormHeader
        headerText='Solicitud de Avalúo'
        headerSubText='Déjanos tus datos y te contactáremos…'
        bottomBorder
      />
      <Section>
        <div className="avaluo-gracias__flex">
          <div className="avaluo-gracias__car">
            <img src={require('./Car.svg')} alt="Car"/>
          </div> 
          <div className="avaluo-gracias__info">
            <h4>Pronto tendrás el Avalúo de tu vehículo</h4>
            <h4>Estas un paso más cerca</h4>
            <p>
            Gracias por completar los datos, pronto recibirás el avalúo de tu vehículo y estás listo para conducir el vehículo de tus sueños.</p>
          </div>
        </div>
        
        <div className="avaluo-gracias__datos">
          <div className="avaluo-gracias__datos-personales">
            <h5>Datos de cliente:</h5>
            <span>{avaluos?.personalInfo?.nombre}</span>
            <span>Email:<br /> {avaluos?.personalInfo?.email}</span>
            <span>Tel: {avaluos?.personalInfo?.telefono}</span>
          </div>
          <div className="avaluo-gracias__datos-vehiculo">
            <h5>Datos de vehículo:</h5>
            <div className="avaluo-gracias__datos-vehiculo-data">
              <div>
                <span>Número de placa: {avaluos?.currentAvaluo?.placa}</span>
                <span>Marca: {avaluos?.currentAvaluo?.marca}</span>
                <span>Modelo: {avaluos?.currentAvaluo?.modelo}</span>
                <span>Año: {avaluos?.currentAvaluo?.anio}</span>
                <span>Kilometraje: {avaluos?.currentAvaluo?.km}</span>
                <span>Tipo de vehiculo: {avaluos?.currentAvaluo?.tipo}</span>
              </div>
              <div>
                <span>Estado: {avaluos?.currentAvaluo?.estado}</span>
                <span>Versión: {avaluos?.currentAvaluo?.version}</span>
                <span>Combustible: {avaluos?.currentAvaluo?.combustible}</span>
                <span>Transmisión: {avaluos?.currentAvaluo?.transmision}</span>
              </div>
            </div>
          </div>
        </div>
        <Steps steps={steps} />
      </Section>
    </div>
  );
};

export default AvaluoGracias;
